export default "__VITE_ASSET__c279e757__"